import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ArrayToStringDirective } from './array-to-string.directive';

@NgModule({
  declarations: [
    ArrayToStringDirective
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ArrayToStringDirective
  ]
})
export class ArrayToStringModule { }
